<template>
  <!-- 续期 -->
  <div class="">

    <el-dialog :visible="isShow" width="540px" :appendToBody='true' :show-close="false" center
      :close-on-click-modal="false" @close="fCancalPopupShow">
      <div class=" x-flex x-row-between  x-p-l-30 x-p-r-30   x-bd-bottom-E">
        <div class='x-flex x-h50 x-cur-poi x-m-r-20 x-font-15'>续期
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="fCancalPopupShow"></i>
        </div>
      </div>
      <div class="x-flex x-col-start x-h400" v-if="type=='renew'">
        <div class="x-w180 x-text-c x-h100p" style="background-color: #F5F7FA;">
          <el-avatar shape="square" class='x-m-t-20' :size='40' :src="require('../assets/img/cmp.png')"></el-avatar>
          <div class="x-font-15 x-p-t-5 c-80">{{$store.state.smSellAdmin.compName}}</div>
          <!-- <div class="x-flex x-row-center x-p-5">
            <div style="background-color: #EAEEF3;border-radius: 10px;">{{mallInfo.mall_id}}</div>
          </div> -->
          <div class="x-p-b-10">
            {{mallInfo.phone}}
          </div>
          <div class='x-p-t-10 x-bd-top c-80  x-flex  x-p-l-20 x-p-r-20'>
            <div class=' dot'></div>门店名称
          </div>
          <div class='x-p-t-10 x-flex x-row-between c-24 x-p-l-20 x-p-r-20'>
            {{mallInfo.mall_name}}
          </div>
          <div class='x-p-t-10 x-flex c-80  x-p-l-20 x-p-r-20'>
            <div class=' dot'></div>绑定手机号
          </div>
          <div class='x-p-t-10 x-flex x-row-between c-24 x-p-l-20 x-p-r-20'>
            {{$store.state.smSellAdmin.shPhone}}
          </div>
          <div class='x-p-t-10 x-flex c-80  x-p-l-20 x-p-r-20'>
            <div class=' dot'></div>到期时间
          </div>
          <div class='x-p-t-10 x-flex x-row-between c-24 x-p-l-20 x-p-r-20'>
            {{mallInfo.stop_time}}
          </div>
          <div class='x-p-t-10 x-p-l-20 x-p-r-20' style="color: red;">
            阿里云数据存储空间已到期
          </div>
        </div>
        <div class="x-flex-1 x-h400">
          <div>
            <div class="   x-flex x-bd-bottom x-cur-poi" v-if="this.$store.state.free_yn == 'Y'">
              <div @click='tagIndx=0' :class="tagIndx==0?'title-active':''" class=" x-p-10" style="margin-right: 50px;">
                扫码续期</div>
              <div @click='tagIndx=1' :class="tagIndx==1?'title-active':''" class=" x-p-10">激活码激活</div>
            </div>
            <div class=" x-p-t-30 x-p-l-40 x-p-r-40 x-flex x-row-between x-h250  x-col-start x-flex-wrap "
              v-show="tagIndx==0" style="overflow-y: auto;overflow-x: hidden;">
              <!-- 容器 -->
              <div class="x-w130 x-h80 x-rela x-cur-poi" @click='activeItem("续期3年")'>
                <!-- <div class="item">永久使用</div> -->
                <div style="position: absolute;top: -6px;right: -4px;">
                  <img style="width:68px ;height: 18px;" src="../assets/img/mdxf-icon.png" >
                </div>
                <!-- 方案 -->
                <div class=" x-m-b-10 x-h80 x-bd x-bd-ra-6 x-flex x-row-center " :class="active=='续期3年'?'active':''"
                  style="user-select:none; border-width: 2px;flex-direction: column;">
                  <div class=" x-p-t-5 x-p-l-5 x-p-r-5 ellipse">续期 <span class="c-smRed f600">3</span> 年</div>
                  <div class=" x-p-b-5 x-font-15 f600" style="">￥{{api.numHelper.fMoneyFat(nf_money3)}}</div>
                  <div class=" x-p-b-5 x-font-12 f600" style="color:  #E2CAB0;">
                    ￥{{api.numHelper.fMoneyFat((Number(nf_money3)/1095).toFixed(2))+ '/天'}}</div>
                </div>
              </div>
              <div class="x-w130 x-h80 x-rela x-cur-poi" @click='activeItem("续期2年")'>
                <!-- <div class="item">永久使用</div> -->
                <!-- 方案 -->
                <div class=" x-m-b-10 x-h80 x-bd x-bd-ra-6 x-flex x-row-center " :class="active=='续期2年'?'active':''"
                  style="user-select:none; border-width: 2px;flex-direction: column;">
                  <div class=" x-p-t-5 x-p-l-5 x-p-r-5 ellipse">续期 <span class="c-smRed f600">2</span> 年</div>
                  <div class=" x-p-b-5 x-font-15 f600" style="">￥{{api.numHelper.fMoneyFat(nf_money2)}}</div>
                  <div class=" x-p-b-5 x-font-12 f600" style="color:  #E2CAB0;">
                    ￥{{api.numHelper.fMoneyFat((Number(nf_money2)/730).toFixed(2))+ '/天'}}</div>
                </div>
              </div>
              <div class="x-w130 x-h80 x-rela x-cur-poi" @click='activeItem("续期1年")'>
                <!-- <div class="item">按年续期</div> -->
                <!-- 方案 -->
                <div class=" x-m-b-10 x-h80 x-bd x-bd-ra-6 x-flex x-row-center " :class="active=='续期1年'?'active':''"
                  style="user-select:none; border-width: 2px;flex-direction: column;">
                  <div class=" x-p-t-5 x-p-l-5 x-p-r-5 ellipse">续期 <span class="c-smRed f600">1</span> 年</div>
                  <div class=" x-p-5 x-font-15 f600" style="">￥{{api.numHelper.fMoneyFat(this.$store.state.fy_money)}}
                  </div>
                  <div class=" x-p-b-5 x-font-12 f600" style="color:  #E2CAB0;">
                    ￥{{api.numHelper.fMoneyFat((Number(this.$store.state.fy_money)/365).toFixed(2))+ '/天'}}</div>
                </div>
              </div>
              <div class="x-w130 x-h80 x-rela x-cur-poi" @click='activeItem("永久续期")'>
                <!-- <div class="item">永久使用</div> -->
                <!-- 方案 -->
                <div class=" x-m-b-10 x-h80 x-bd x-bd-ra-6 x-flex x-row-center " :class="active=='永久续期'?'active':''"
                  style="user-select:none; border-width: 2px;flex-direction: column;">
                  <div class=" x-p-t-5 x-p-l-5 x-p-r-5 ellipse">永久续期</div>
                  <div class=" x-p-b-5 x-font-15 f600" style="">￥{{api.numHelper.fMoneyFat(sell_md_money)}}</div>
                </div>
              </div>
            </div>
            <div class="  x-p-l-40 x-p-r-40 x-flex x-row-between x-h150    " v-show="tagIndx==1"
              style="overflow-y: auto;overflow-x: hidden;">
              <div class="x-w80">激活码</div>
              <el-input v-model="pro_code"></el-input>
            </div>
          </div>
          <div class="x-p-l-20 c-80  x-font-12">
            <div class="x-p-b-10">温馨提示：你的数据存储在阿里云上，请放心一切数据安全！</div>
            <div>如有疑问请拨打：{{$store.state.smSellAdmin.partnerPhone}}</div>
          </div>
          <div class=" x-flex x-p-t-10 x-row-right x-p-r-20">
            <x-button v-show="tagIndx==0" bgc='#FF4646' border='none' color='#fff' width='100px' height='36px'
              @click.native='fRecharge'>
              立即支付</x-button>
            <x-button v-show="tagIndx==1" bgc='#FF4646' border='none' color='#fff' width='100px' height='36px'
              @click.native='fAct'>
              立即激活</x-button>
          </div>
        </div>
      </div>
      <div class="x-flex x-col-start x-h350" v-else>
        <div class="x-flex x-w100p" style="flex-direction: column;">
          <div class='x-p-t-30 '>数据存储空间续期成功</div>
          <div class='x-p-t-10 f600 x-font-20 ' style="color: #FF5E44;">{{params.msg}}</div>
          <div class='x-p-t-10 f600  x-flex x-p-b-30'>
            <div>可用日期至：</div>
            <div style="color: #FF5E44;" v-if='params.msg=="续期1年"'>
              {{api.timeHelper.manyDaysLater(Number(mallStopDay)+365,6)}}
            </div>
            <div style="color: #FF5E44;" v-if='params.msg=="续期2年"'>
              {{api.timeHelper.manyDaysLater(Number(mallStopDay)+730,6)}}
            </div>
            <div style="color: #FF5E44;" v-if='params.msg=="续期3年"'>
              {{api.timeHelper.manyDaysLater(Number(mallStopDay)+1095,6)}}
            </div>
            <div style="color: #FF5E44;" v-if='params.msg=="永久续期"'>
              无限制</div>
            <div style="color: #FF5E44;" v-if='params.msg=="激活成功"'>
              {{params.stop_time}}
            </div>
          </div>
          <div class='x-p-t-20 c-80'>感谢您的支持，有任何问题可以联系我们</div>
          <div class='x-p-t-10 c-80 x-p-b-50'>你的满意，一直是我们不懈的追求！</div>
          <div class='x-p-t-10 x-p-b-30'>
            <x-button bgc='#FF4646' border='none' color='#fff' width='100px' height='36px'
              @click.native='fCancalPopupShow("Y")'>
              开始使用</x-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <smRecharge :isShow="payQrPop" :params='params' @cencal='fCancalPay' type='smSellNfMoney'></smRecharge>
  </div>
</template>

<script>
  import smRecharge from '../components/smRecharge.vue'
  export default {
    components: {
      smRecharge
    },
    props: {
      canClose: {
        type: [String, Boolean],
        default: false,
      },
      // 是否显示
      isShow: {
        type: [String, Boolean],
        default: false,
      },
      // mallInfo: [Array, Object],
      // default: () => {
      //   return []
      // },
      shPhone: {
        type: [String, Boolean],
        default: '4008768278',
      },
      mallId: {
        type: [String, Boolean],
        default: '00010001',
      },

      oper: {
        type: [String, Boolean],
        default: false,
      },
      mallStopDay: {
        type: [String, Boolean],
        default: false,
      },
    },
    data() {
      return {
        tagIndx: 1, //this.$store.state.create_day >= 180 ? 0 : 1,
        type: 'renew',
        payQrPop: false,
        params: {},
        sell_md_money: '',
        nf_money2: '',
        nf_money3: '',
        active: '续期1年',
        renewList: [], //充值方案列表
        cz_jf: '',
        zs_money: '',
        mallInfo: {},
        dyXp: false, //打印小票
        inputCur: true,
        // active: '积分',
        //光标定时器
        time: null,
        // 页
        TP: 0,
        TR: 0,
        page: {
          pageSize: 50,
          nowPage: 1
        },
        pro_code: ''
      }

    },
    created() {
      // this.init()
    },
    watch: {
      isShow(newVal) {
        if (newVal) {
          this.init()
        }
      }
    },
    methods: {
      async init() {
        this.tagIndx = this.$store.state.free_yn == 'Y' ? 0 : 1
        this.params = {}
        let resMall = await this.fGetMallInfo()
        if (resMall.result != 'sucess') {
          return this.$message(resMall.msg)
        }
        this.mallInfo = resMall.data[0]
        let resCzRule = await this.fGetMainSrvMchInfo()
        if (resCzRule.result != 'sucess') {
          return this.$message(resCzRule.msg)
        }
        this.sell_md_money = resCzRule.data[0].sell_md_money
        this.nf_money2 = resCzRule.data[0].nf_money2
        this.nf_money3 = resCzRule.data[0].nf_money3
      },
      activeItem(type) {
        this.active = type
      },
      //充值弹窗
      fRecharge() {
        if (this.api.smCom.fSmIsEmpty(this.active)) {
          return this.$message('请选择续期方案')
        }
        this.payQrPop = true
        if (this.active == '续期1年') {
          this.params = {
            msg: this.active,
            money: this.$store.state.fy_money,
            num: 365,
          }
        }
        if (this.active == '续期2年') {
          this.params = {
            msg: this.active,
            money: this.nf_money2,
            num: 730,
          }
        }
        if (this.active == '续期3年') {
          this.params = {
            msg: this.active,
            money: this.nf_money3,
            num: 1095,
          }
        }
        if (this.active == '永久续期') {
          this.params = {
            msg: this.active,
            money: this.sell_md_money,
            num: 36500,
          }
        }

      },
      //关闭弹窗
      fCancalPopupShow(useYn) {
        if (useYn == 'Y' || this.type == 'paySucess') {
          this.$emit("cencal", this.mallInfo.mall_id);
          return
        }
        if (this.canClose == 'N') {
          return this.$message('门店已到期或即将到期，为了不影响正常使用，请先续期')
        }
        this.$emit("cencal", this.mallInfo.mall_id);
      },
      fCancalPay(e) {
        if (!this.api.smCom.fSmIsEmpty(e)) {
          this.type = 'paySucess'
        }
        this.payQrPop = false
        Object.assign(this.params, e)
      },
      async fAct() {
        if (this.api.smCom.fSmIsEmpty(this.pro_code)) {
          return this.$message('请输入激活码')
        }
        this.$confirm('是否确认激活', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {

          let res = await this.fProCodeManger()
          if (res.result != 'sucess') {
            return this.$message(res.msg)
          }
          this.type = 'paySucess'
          this.params = {
            msg: '激活成功',
            stop_time: res.stop_time
          }
        }).catch(() => {});
      },
      //请求开始===============
      //获取门店信息
      async fGetMallInfo(obj) {
        let js = {};
        js['OPER'] = 'MALL_ID'
        js['MALL_ID'] = this.mallId
        let res = await this.api.smSellApi.fPostToSmSellQueryApi('GET_MALL_INFO', js)
        return res;
      },

      //获取
      async fGetMainSrvMchInfo() {
        let js = {};
        js['OPER'] = 'FY_MONEY';
        js['SH_PHONE'] = this.shPhone;
        js['MALL_ID'] = this.mallId
        let res = await this.api.smSellApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js)
        return res;
      },
      async fProCodeManger() {
        let js = {};
        // 批量绑定或划拨给服务商 BACH_CHG_ORG BACH_CHG_PRO_ORG
        js['OPER'] = 'ACTIVE_SAAS' //'BACH_ADD'//
        js['PRO_TYPE'] = 'SAAS'
        js['CHG_USER_NAME'] = this.$store.state.smSellAdmin.userName
        js['PRO_CODE'] = this.pro_code
        js['ORG_ID'] = '18957102098'
        js['MCH_ID'] = this.shPhone
        js['STORE_ID'] = this.mallId
        let res = await this.api.smSellApi.fPostToSmSellMainSrvApi("PRO_CODE_MANGER", js, '',
          'smSell719ee78131675d5ed4cacbe41e1c8191Api');
        return res;
      },


      //请求结束===============






    }
  }
</script>

<style lang="less" scoped="scoped">
  /deep/.el-input__icon {
    line-height: unset;
  }

  // .vip-recharge{
  //添加嵌套多出来的头部
  /deep/.el-dialog__header {
    display: none;
  }

  //添加嵌套多出来的内边距
  /deep/.el-dialog__body {
    padding: 0px 0px;
  }

  .proImg {
    /deep/.el-image {
      border-radius: 4px 4px 0 0;
    }
  }

  .active {
    border: 1px solid #FF4646;
    color: #F42D23;
    background-color: #FFFAFA;
  }

  .title-active {
    border-bottom: 1px solid #FF4646;
    color: #F42D23;
  }

  .click {
    background-color: #F9FAFC;
  }

  .dot {
    width: 6px;
    height: 6px;
    background-color: #D3D9DF;
    margin: 2px 10px 2px 2px;
    border-radius: 50%;
  }

  .c-d3 {
    color: #D3D9DF;
  }

  .item {
    width: 62px;
    height: 20px;
    // background-image: linear-gradient(to right, #595E68, #28232B);
    border-radius: 0 10px 0 0;
    position: absolute;
    right: -2px;
    top: -2px;
    color: #E2CAB0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mallRenew.vue